import { render, staticRenderFns } from "./OrderServicesTab.vue?vue&type=template&id=14bb3646&scoped=true&"
import script from "./OrderServicesTab.vue?vue&type=script&lang=js&"
export * from "./OrderServicesTab.vue?vue&type=script&lang=js&"
import style0 from "./OrderServicesTab.vue?vue&type=style&index=0&id=14bb3646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bb3646",
  null
  
)

export default component.exports